import { render, staticRenderFns } from "./ExchangeHistory.vue?vue&type=template&id=23f408f8&scoped=true"
import script from "./ExchangeHistory.vue?vue&type=script&lang=js"
export * from "./ExchangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f408f8",
  null
  
)

export default component.exports